/** Contracts (F44) as the API sends them. `amountGrosze` is missing for whoever may not see it. */
export const CONTRACTS_RESOURCE = 'contracts.contracts';
export const PERSON_DATA_RESOURCE = 'contracts.person_data';
export const TEMPLATES_RESOURCE = 'contracts.templates';
export const CONTRACTS_SETTINGS_RESOURCE = 'contracts.settings';
export const CONTRACTS_KEY = ['contracts'] as const;

export type ContractKind = 'dzielo' | 'zlecenie';
export const KINDS: Record<ContractKind, string> = { dzielo: 'Umowa o dzieło', zlecenie: 'Umowa zlecenie' };
export type ContractState = 'szkic' | 'wygenerowana' | 'podpisana' | 'anulowana';
export const STATES: Record<ContractState, string> = { szkic: 'Szkic', wygenerowana: 'Wygenerowana', podpisana: 'Podpisana', anulowana: 'Anulowana' };

export type Contract = {
  id: string;
  kind: ContractKind;
  number: string;
  title: string;
  personId: string;
  personName: string;
  eventId: string | null;
  eventName: string | null;
  templateId: string;
  subject: string;
  amountGrosze?: number;
  dateFrom: string;
  dateTo: string;
  signedOn: string | null;
  state: ContractState;
  pdfFileId: string | null;
  signedFileId: string | null;
  generatedAt: string | null;
  createdAt: string;
  version: number;
  /** Card only: placeholders without a value (generating is refused until they are filled). */
  missing?: string[];
};
export type ContractFile = { fileId: string; kind: 'pdf' | 'skan'; name: string; createdAt: string; current: boolean };
export type Template = { id: string; kind: ContractKind; name: string; body: string; version: number };
export type CompanyData = { companyName: string; companyAddress: string; companyNip: string; version: number };
/** Every field but the person's id may be missing (hidden from the role). `version` null: nothing saved yet. */
export type PersonData = { personId: string; address?: string; pesel?: string; birthDate?: string | null; bankIban?: string; taxOffice?: string; version: number | null };

/** The template placeholders' Polish names (the same as the server's list). */
export const PLACEHOLDERS: Record<string, string> = {
  osoba: 'Imię i nazwisko osoby',
  adres: 'Adres osoby',
  pesel: 'PESEL',
  przedmiot: 'Przedmiot umowy',
  kwota: 'Kwota brutto (cyframi)',
  kwota_slownie: 'Kwota brutto słownie',
  od: 'Początek okresu',
  do: 'Koniec okresu',
  data: 'Data zawarcia umowy',
  numer: 'Numer umowy',
  firma: 'Nazwa firmy',
  firma_adres: 'Adres firmy',
  firma_nip: 'NIP firmy',
};

/** '2026-11-07' → '07.11.2026'. */
export const plDay = (day: string) => `${day.slice(8, 10)}.${day.slice(5, 7)}.${day.slice(0, 4)}`;
export const fileUrl = (fileId: string) => `/api/files/${fileId}`;
